export class BatchDelete<T> {
	constructor(public data: T) {}
}
